// extracted by mini-css-extract-plugin
export default {"container":"dynamicPageLoader__container__c6At1","component":"dynamicPageLoader__component__tpqqn","active":"dynamicPageLoader__active__aVwFB"};